import React, { useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { logEvent } from '../../utils/analytics';
import './ForbiddenPage.css';

const Forbidden = () => {
  const navigate = useNavigate();
  
  // 設置頁面標題
  useEffect(() => {
    logEvent('auth_gate_view', { status: 'forbidden' });
  }, []);

  useEffect(() => {
    document.title = '禁止瀏覽 - 403';
  }, []);

  // 聯絡管理員的處理函數
  const handleContactAdmin = () => {
    window.open('mailto:admin@nogi46.me?subject=瀏覽權限申請');
  };

  return (
    <div className="forbidden-container">
      <div className="forbidden-content">
        <div className="forbidden-header">
          <h2>禁止瀏覽 (403)</h2>
        </div>
        
        <div className="forbidden-body">
          <Alert variant="danger" className="mb-4">
            <Alert.Heading>抱歉，您無權瀏覽此頁面</Alert.Heading>
            <p>
              您嘗試瀏覽的頁面需要特定的權限才能查看。如果您認為這是一個錯誤，請聯絡系統管理員。
            </p>
            <hr />
            <p className="mb-0">
              如有疑問，請洽管理員：<a href="mailto:admin@nogi46.me">admin@nogi46.me</a>
            </p>
          </Alert>

          <div className="forbidden-animation">
            <div className="animation-wrapper">
              <img 
                src="/images/gif/kaki.gif"
                alt="禁止瀏覽"
                className="forbidden-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <p className="animation-caption">取得適當權限後才能瀏覽此頁面...</p>
          </div>

          <div className="forbidden-actions">
            <Button 
              variant="primary" 
              size="lg" 
              onClick={() => navigate('/')}
            >
              返回首頁
            </Button>
            <Button variant="outline-secondary" size="lg" onClick={handleContactAdmin}>
              聯絡管理員
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;